import { WIX_BLOG } from '@wix/app-definition-ids';
import { useErrorHandler, useExperiments, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { updateBlogPostsAltText } from '../../../api/new-infra-updates/update-blog-posts-alt-text';
import { altTextScreenPageIdAtom } from '../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../hooks/rules-state';
import { useNavigation } from '../../../hooks/use-navigation';
import { useImageElementsOrder } from '../alt-text/use-image-elements-order';
export const useBlogPostsAltTextHandlers = () => {
  const {
    getPagesData
  } = usePanelStateAtom();
  const pageIdToPageData = getPagesData();
  const navigateToPage = useNavigation();
  const {
    getOrderedImageElements
  } = useImageElementsOrder();
  const altTextScreenPageId = useAtomValue(altTextScreenPageIdAtom);
  assertNotOptional(altTextScreenPageId);
  const {
    pageId
  } = altTextScreenPageId;
  const errorHandler = useErrorHandler();
  const httpClient = useHttpClient();
  const {
    experiments
  } = useExperiments();
  const innerRoutes = useMemo(() => {
    var _pageIdToPageData$get;
    return (_pageIdToPageData$get = pageIdToPageData.get(pageId)) == null ? void 0 : _pageIdToPageData$get.innerRoutes;
  }, [pageId, pageIdToPageData]);
  const openImageElement = useCallback(nextElement => {
    navigateToPage(pageId, nextElement.entityId);
  }, [navigateToPage, pageId]);
  const getEntityName = useCallback(entityId => {
    var _innerRoutes$find;
    return (innerRoutes == null || (_innerRoutes$find = innerRoutes.find(innerRoute => innerRoute.id === entityId)) == null ? void 0 : _innerRoutes$find.name) ?? '';
  }, [innerRoutes]);
  const getElementOrder = useCallback(altImageRuleProps => getOrderedImageElements(altImageRuleProps), [getOrderedImageElements]);
  const enabledDecorativeImages = false;
  const appDefinitionId = WIX_BLOG;
  const setBulkAltText = useCallback(async bulkAltTextData => {
    const response = await updateBlogPostsAltText(httpClient, errorHandler, bulkAltTextData, spec => experiments.enabled(spec));
    if (response.success === false) {
      throw new Error(response.errorMessage);
    }
  }, [errorHandler, httpClient, experiments]);
  return useMemo(() => ({
    appDefinitionId,
    enabledDecorativeImages,
    getElementOrder,
    getEntityName,
    openImageElement,
    setBulkAltText
  }), [appDefinitionId, getElementOrder, enabledDecorativeImages, getEntityName, openImageElement, setBulkAltText]);
};
//# sourceMappingURL=use-blog-posts-alt-text-rule-handlers.js.map